import { safeDefine } from "../../registration/safe-define.js";
import { GoogleCastExtension } from "../../extensions/google-cast/extension.js";
//#region src/define/extensions/google-cast.ts
safeDefine(GoogleCastExtension);
//#endregion
export { GoogleCastExtension };
